import React, { useEffect, useState } from 'react';
import { CustomButton } from '../Button/Button';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import styles from './CreateFolderModal.module.scss';
import InputFolder from './InputFolder';
import { useLibraryContext } from '../../context/LibraryContext';
import { useHistory } from 'react-router-dom';
import { ToastNotification } from '../Toast/Toast';
import { MAX_NAME_LENGTH } from '../../../common/constants/common';
import { clearEmojis } from '../../utils/stringHelper';

const CreateFolderModal = ({ isRedirect, defaultName, createFolder, isShow, onClose }) => {
  const [name, setName] = useState('');

  const { toggleUnselectFolders } = useLibraryContext();

  const { t } = useTranslation();
  const history = useHistory();
  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);
  const [isFolderLoading, setIsFolderLoading] = useState(false);

  useEffect(() => {
    setName(defaultName);
    toggleUnselectFolders();
  }, [isShow]);

  const handleChangeName = event => {
    const name = clearEmojis(event.target.value.substring(0, 100));
    setName(name);
  };

  const handleCreateFolder = async () => {
    try {
      setIsFolderLoading(true);
      await createFolder(name);

      if (isRedirect) {
        history.push('/eg/dashboard', { folders: true });
      }
    } catch (e) {
      ToastNotification({
        message: `${e.message}. ${t('general.toast.error_folder_already_exist.part_two')}`,
        isMobileView: isMobileView,
      });
    } finally {
      setIsFolderLoading(false);
    }
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('create_folder_modal.title')}</span>
        </div>
        <div>
          <InputFolder className={styles.inputFolder} value={name} onChange={handleChangeName} maxLength={MAX_NAME_LENGTH} />
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
          <CustomButton
            className={styles.createBtn}
            variant="primary"
            label={t('general.create')}
            disabled={!name || name.startsWith(' ')}
            loading={isFolderLoading}
            loadingText={t('general.creating')}
            onClick={handleCreateFolder}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CreateFolderModal;
